import React from "react";
import Image from "next/image";
import { useRouter } from "next/router";
import { TopProductTag } from "@/components/us-website/IndustryList/IndustryList";
import { EnhancedProductName } from "@/components/Products/ProductNameDisplay";
import { getCDNImageUrl, slugify } from "@/utils/Common";
import { FAQ_SLUG } from "@/constastants/Constant";

const FALLBACK_IMAGE = getCDNImageUrl("dummy-product-image.webp");

export default function FaqHubProductCard({ product }) {
  const router = useRouter();

  if (!product?.id) return null;

  const name = product.ChemicalName || "";
  const faqHref = `/${FAQ_SLUG}/${slugify(name)}-${product.id}`;

  const handleCardClick = () => {
    router.push(faqHref);
  };

  const imgSrc = product.image || product.ProductImage || FALLBACK_IMAGE;

  return (
    <div
      onClick={handleCardClick}
      className="flex w-full max-w-[400px] cursor-pointer flex-col justify-between justify-self-center rounded-[16px] border border-[rgba(4,9,25,0.06)] p-4 bg-white"
    >
      <div className="flex flex-col gap-2">
        <div className="relative w-full h-[160px] rounded-t-[16px] overflow-hidden">
          <Image
            src={imgSrc}
            alt={name || "product-image"}
            fill
            className="object-cover rounded-t-[16px]"
          />
          {product?.is_topProduct ? <TopProductTag /> : null}
        </div>

        <div className="mb-10">
          <EnhancedProductName
            name={name}
            brandName={product?.Brand_Name}
            className="text-[24px] leading-[1.5] font-medium text-black line-clamp-2 md:text-[24px] max-md:text-[20px] max-md:leading-[1.4] max-md:text-[#2c2f38]"
            showChemicalName={true}
          />
        </div>
      </div>

      <div className="flex flex-col items-start gap-2">
        <div className="text-[14px] leading-[1.5] font-normal text-[rgba(4,9,25,0.6)] max-md:text-[12px] max-md:text-[rgba(89,94,112,1)]">
          {(() => {
            const text = product?.summary || product?.Productdescription || "Product description not available.";
            return text.length > 240 ? text.slice(0, 240) + "…" : text;
          })()}
        </div>

        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            router.push(faqHref);
          }}
          className="text-[14px] font-medium text-black underline outline-none border-none bg-none cursor-pointer max-md:text-[12px] max-md:leading-[1.5] max-md:font-normal max-md:tracking-[0.1px] max-md:text-[#2c2f38]"
        >
          View Details
        </button>

        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            router.push(faqHref);
          }}
          className="font-medium text-[14px] border w-full rounded-[8px] py-2 border-[#EE4137] text-[#EE4137] cursor-pointer bg-white"
        >
          View FAQs
        </button>
      </div>
    </div>
  );
}
